<template>
  <div class="product-information-card" :class="[`theme-${theme}`]">
    <div class="product-information-card__type">
      <i :class="icon"></i>
    </div>
    <div class="top">
      <div class="image-wrap">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
          <filter id="blur">
              <feGaussianBlur stdDeviation="10" />
          </filter>
        </svg>
        <div class="background-mask">
          <div class="background-mask__shade" v-if="_get(productDetails, 'Image.path')"></div>
          <div class="full-picture blur" :style="backgroundMaskImage()"></div>
        </div>
        <div class="image-circle">
          <div class="image" :style="picture()"></div>
          <i :class="icon"></i>
        </div>
        <div class="kcal-circle" v-if="_get(productDetails, 'energy_kcal')">
          <nuttrema-dot-kcal :energyKcal="_get(productDetails, 'energy_kcal')" class="is-medium"></nuttrema-dot-kcal>
        </div>
      </div>
      <div v-show="!isReady">
        <span class="text-dummy-loader"></span>
        <span class="text-dummy-loader is-slim-wide"></span>
      </div>
      <div v-show="isReady">
        <p class="name" v-if="productDetails.name">
          <span>{{ productDetails.name }}</span>
        </p>
        <p class="description" v-if="productDetails.description">
          <span>{{ productDetails.description }}</span>
        </p>
      </div>
    </div>
    <p v-if="dividerTitle" class="ui-element horizontal-divider">
      <span>{{ dividerTitle }}</span>
    </p>
    <hr v-else>
  </div>
</template>

<script>
import { get } from 'lodash';

import NuttremaDotKcal from 'components/ui/label/nuttrema-dot-kcal';
import ProductInformationCard from './product-information-card';

export default {
  name: 'stuff-to-eat-product-information-card',
  mixins: [ProductInformationCard],
  components: {
    NuttremaDotKcal,
  },
  methods: {
    picture() {
      const imagesRoot = process.env.IMAGES_ROOT;
      const path = get(this.productDetails, 'Image.path', false);
      const filename = get(this.productDetails, 'Image.thumbnails.large.filename', false);
      const fullPath = (imagesRoot && path && filename) ? imagesRoot + path + filename : '';
      return `backgroundImage: url(${fullPath})`;
    },
    backgroundMaskImage() {
      return this.picture();
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/ui/card/stuff-to-eat-product-information-card.vue